module.exports = __webpack_public_path__ + "static/img/bannerApp2-2.474931d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/bannerApp2-2.jpg
// module id = L+Gu
// module chunks = 1